import { AppDescription } from '@/components/atoms/AppDescription/AppDescription'
import { AppTitle } from '@/components/atoms/AppTitle/AppTitle'
import { Button, Flex, Modal } from 'antd'
import React from 'react'

type Props = {
  onClose: () => void;
  open: boolean;
}

export function AuthLedgerAppNotConnected({ onClose, open }: Props) {
  return (
    <Modal
      rootClassName="errorLedgerModal"
      onCancel={onClose}
      open={open}
      footer={null}
      title={null}
      transitionName={null}
      maskTransitionName={null}
    >
      <Flex justify="center" align="center" gap={30} vertical>
        <Flex vertical gap={15}>
          <span style={{ fontSize: '60px', display: 'block', textAlign: 'center', lineHeight: '70px' }}>🚫</span>
          <AppTitle centered text="Ledger Device Not Detected" />
          <AppDescription
            centered
            description={(
              <>
                Please connect your Ledger device,
                <br />
                ensure it is unlocked.
              </>
          )}
          />
        </Flex>
        <Button onClick={onClose} className="mobilePrimaryButton" block type="primary">Got it</Button>
      </Flex>
    </Modal>
  )
}
